
<template>
  <div>
    <section class="content">
      <div
        class="agent-list"
        v-for="item in userList"
        v-bind:key="item.uid"
      >
        <h4>
          {{item.uid}}
          <span
            class="agent-list-id"
            v-show="false"
          >
            ( id_
            <span>xjioa355bhhd</span> )
          </span>
          <span
            class="badge agent-list-badge"
            v-show="item.uid == $router.app.$store.state.user.uid "
          >Me</span>
          <button
            class="btn btn-warning btn-sm btn-agent-edit pull-right"
            data-toggle="modal"
            v-if="isAdmin"
            v-on:click="handleEditPrivilege(item)"
          >Privileges</button>
          <button
            class="btn btn-info btn-sm btn-agent-edit pull-right"
            data-toggle="modal"
            v-if="item.permission < currentUserPermission || $router.app.$store.state.user.pm > 888"
            v-on:click="toEditUser(item)"
          >Edit</button>
        </h4>
        <span v-if="item.permission >= 888">
          <i class="fa fa-star"></i> Admin
        </span>
        <span v-else>
          <i class="fa fa-star-o"></i> User
        </span>
      </div>
    </section>
    <!-- /.content -->
    <!-- add Agent -->
    <div
      class="add-app-bgcolor dropup"
      v-show="isAdminInApp"
    >
      <button data-toggle="dropdown" class="add-app-btn">
        <span class="btn add-app">
          <i class="fa fa-plus"></i>
        </span>
      </button>
      <ul
        class="dropdown-menu pull-right add-btn-dropdown-menu"
      >
        <li>
          <a
            class="add-agent-choose"
            data-toggle="modal"
            data-target="#modal-add-existing-agent"
            v-on:click="toGetExistUser"
          >Add Existing Agents</a>
        </li>
        <li>
          <a
            class="add-agent-choose"
            data-toggle="modal"
            v-on:click="toShowNewUserModal"
          >New An Agent</a>
        </li>
      </ul>
    </div>
    <!-- /add Agent -->
    <privilege-modal ref="privilegeModal"/>
    <!--edit dialog-->
    <div class="modal fade in" id="modal-edit-agent">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Edit Agent's Authority</h4>
          </div>
          <div class="modal-body">
            <form class="form-horizontal">
              <!--<p class="agent-edit-modal-id"><label>Agent Name:&nbsp;&nbsp;</label>name</p>-->
              <!--<p class="agent-edit-modal-id"><label>Agent ID:&nbsp;&nbsp;</label>xjioa355bhhd</p>-->
              <div class="form-group">
                <label
                  class="col-sm-3 control-label agent-edit-modal-name"
                >Agent ID</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <input
                    class="form-control"
                    placeholder="Agent uid"
                    v-model="editUser.uid"
                    disabled
                  >
                </div>
              </div>
              <div class="form-group">
                <label
                  class="col-sm-3 control-label agent-edit-modal-name"
                >Password</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <input
                    class="form-control"
                    placeholder="Keep the current password"
                    v-model="editUser.password"
                  >
                </div>
              </div>
              <div class="form-group">
                <label
                  class="col-sm-3 control-label agent-edit-modal-name"
                >E-mail Address</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <input
                    class="form-control"
                    v-model="editUser.email"
                    placeholder="E-mail Address..."
                  >
                </div>
              </div>
              <div class="form-group" v-show="true">
                <label
                  class="col-sm-3 agent-edit-modal-name control-label"
                >Agent's Authority</label>
                <div
                  v-if="$router.app.$store.state.user.pm > 888"
                  class="col-sm-9 agent-edit-modal-name"
                >
                  <select
                    class="form-control"
                    v-model="editUser.permission"
                  >
                    <option>Admin</option>
                    <option>User</option>
                  </select>
                </div>
                <div
                  class="col-sm-9 agent-edit-modal-name"
                  v-else
                >
                  <select
                    class="form-control"
                    v-model="editUser.permission"
                    disabled
                  >
                    <option>Admin</option>
                    <option>User</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-toggle="dropdown"
            >Delete Agent</button>
            <ul class="dropdown-menu pull-left alert-del">
              <li>
                <i
                  class="icon fa fa-warning alert-del-warning"
                ></i>Confirm to delete ?
              </li>
              <li>
                <button class="btn btn-default">Cancel</button>
                <button
                  class="btn btn-danger"
                  v-on:click="toDeleteUser"
                >Delete</button>
              </li>
            </ul>
            <button
              type="button"
              class="btn btn-info"
              v-on:click="toUpdataUser"
            >Save changes</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ edit dialog-->
    <!--new agent dialog-->
    <div class="modal fade in" id="modal-new-an-agent">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Edit Agent's Authority</h4>
          </div>
          <div class="modal-body">
            <form class="form-horizontal">
              <!--<p class="agent-edit-modal-id"><label>Agent Name:&nbsp;&nbsp;</label>name</p>-->
              <!--<p class="agent-edit-modal-id"><label>Agent ID:&nbsp;&nbsp;</label>xjioa355bhhd</p>-->
              <div class="form-group">
                <label
                  class="col-sm-3 control-label agent-edit-modal-name"
                >Agent ID</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <input
                    class="form-control"
                    placeholder="Necessary"
                    v-model="newUser.uid"
                  >
                </div>
              </div>
              <div class="form-group">
                <label
                  class="col-sm-3 control-label agent-edit-modal-name"
                >Password</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <input
                    class="form-control"
                    placeholder="Necessary"
                    v-model="newUser.password"
                  >
                </div>
              </div>
              <div class="form-group">
                <label
                  class="col-sm-3 control-label agent-edit-modal-name"
                >E-mail Address</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <input
                    class="form-control"
                    placeholder="Necessary"
                    v-model="newUser.email"
                  >
                </div>
              </div>
              <div
                class="form-group"
                v-if="currentUserPermission > 888"
              >
                <label
                  class="col-sm-3 agent-edit-modal-name control-label"
                >Agent's Authority</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <select
                    class="form-control"
                    v-model="newUser.permission"
                  >
                    <option>Admin</option>
                    <option>User</option>
                  </select>
                </div>
              </div>
              <div class="form-group" v-else>
                <label
                  class="col-sm-3 agent-edit-modal-name control-label"
                >Agent's Authority</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <select
                    class="form-control"
                    v-model="newUser.permission"
                    disabled
                  >
                    <option>Admin</option>
                    <option>User</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
            >Cancel</button>
            <button
              type="button"
              class="btn btn-info"
              v-on:click="toNewUser"
            >Save changes</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ new agent dialog-->
    <!--choose existing agent dialog-->
    <div
      class="modal fade in"
      id="modal-add-existing-agent"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Add Existing Agents</h4>
          </div>
          <div class="modal-body">
            <form>
              <div class="table-responsive">
                <table
                  class="choose-existing-agent-table table-striped"
                >
                  <tbody
                    v-for="item in existedUser"
                    v-bind:key="item.uid"
                  >
                    <tr
                      class="choose-existing-agent-row"
                      role="row"
                    >
                      <td
                        class="col-xs-1 choose-existing-agent-checkbox"
                        v-if="item.hasAdd == true"
                      >
                        <input
                          type="checkbox"
                          class="choose-existing-agent-checkbox-input"
                          checked
                          disabled
                          v-model="item.isCheck"
                        >
                      </td>
                      <td
                        class="col-xs-1 choose-existing-agent-checkbox"
                        v-else-if="item.isCheck == true"
                      >
                        <input
                          type="checkbox"
                          class="choose-existing-agent-checkbox-input"
                          checked
                          v-model="item.isCheck"
                        >
                      </td>
                      <td
                        class="col-xs-1 choose-existing-agent-checkbox"
                        v-else
                      >
                        <input
                          type="checkbox"
                          class="choose-existing-agent-checkbox-input"
                          v-model="item.isCheck"
                        >
                      </td>
                      <!--<td class="col-xs-3"><span>Agent Name</span></td>-->
                      <td class="col-xs-4">
                        <span>Agent ID:&nbsp;</span>
                        <span>{{item.uid}}</span>
                      </td>
                      <td
                        class="col-xs-5"
                        v-if="$router.app.$store.state.user.pm > 888&&item.hasAdd != true"
                      >
                        <span>Authority:&nbsp;</span>
                        <select
                          class="choose-existing-agent-select"
                          v-model="item.permission"
                        >
                          <option>Admin</option>
                          <option>User</option>
                        </select>
                      </td>
                      <td class="col-xs-5" v-else>
                        <span>Authority:&nbsp;</span>
                        <select
                          class="choose-existing-agent-select"
                          v-model="item.permission"
                          disabled
                        >
                          <option>Admin</option>
                          <option>User</option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              v-on:click="toSelectAllExistUser"
              v-show="!isSelectAll"
            >Select All</button>
            <button
              type="button"
              class="btn btn-default pull-left"
              v-on:click="toSelectAllExistUser"
              v-show="isSelectAll"
            >DeSelect All</button>
            <button
              type="button"
              class="btn btn-info"
              v-on:click="toAddExistUser"
            >Save changes</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ choose existing agent dialog-->
  </div>
</template>
<script>
import { stats } from "../../demo";
import api from "../../api";
import utils from "../../utils";
import global from "../Global.vue";
import config from "../../config";
import PrivilegeModal from "../modules/PrivilegeModal.vue";

const pluginURL =
  "/static/js/plugins/jvectormap/jquery-jvectormap-2.0.3.min.js";
const mapURL = "/static/js/plugins/jvectormap/jquery-jvectormap-world-mill.js";

export default {
  name: "Agent",
  data() {
    return {
      stats,
      userList: [],
      isSelectAll: false,
      currentUserPermission: "",
      isAdminInApp: config.isAdminInApp,
      existedUser: [],
      editUser: {
        permission: "User"
      },
      newUser: {
        permission: "User"
      },
      isAdmin: utils.checkIsAppAdmin()
    };
  },
  components: {
    PrivilegeModal
  },
  created() {
    this.$bus.on("searchagent", this.init);
  },
  beforeDestroy() {
    this.$bus.off("searchagent", this.init);
  },
  methods: {
    init(key) {
      if (utils.isEmpty(key) || utils.isEmpty(key.key)) {
        this.toGetAllAgent();
      } else {
        this.toGetAllAgentByUid(key.key);
      }
    },
    isBurgApp: function() {
      return this.$route.query.appid === config.burgAppid;
    },
    toNewUser() {
      if (
        typeof this.newUser.uid === "undefined" ||
        typeof this.newUser.password === "undefined" ||
        typeof this.newUser.permission === "undefined" ||
        typeof this.newUser.email === "undefined"
      ) {
        alert("input error");
        return;
      }
      var user = {
        appid: this.$route.query.appid,
        uid: this.newUser.uid,
        password: this.newUser.password,
        email: this.newUser.email,
        permission: this.newUser.permission
      };
      var params = new URLSearchParams();
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(user), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api.request("post", "/adduser?_type=json", params).then(response => {
        var data = response.data;

        if (data.Status !== 1) {
          var errorName = data.ErrorMessage;
          //              添加失败
          if (errorName) {
            utils.showMsg(errorName);
          } else {
            utils.showMsg("add fail");
          }
          return;
        } else {
          window.location.reload();
        }
      });
    },
    toDeleteUser() {
      var user = {
        appid: this.$route.query.appid,
        uid: this.editUser.uid
      };
      var params = new URLSearchParams();
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(user), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api
        .request("post", "/deleteuserbyappidanduid?_type=json", params)
        .then(response => {
          var data = response.data;

          if (data.Status !== 1) {
            var errorName = data.ErrorMessage;
            if (errorName) {
              utils.showMsg(errorName);
            } else {
              utils.showMsg("delete fail");
            }
            return;
          } else {
            window.location.reload();
          }
        });
    },
    toUpdataUser() {
      var user = {
        appid: this.$route.query.appid,
        uid: this.editUser.uid,
        password: this.editUser.password,
        permission: this.editUser.permission,
        email: this.editUser.email
      };
      var params = new URLSearchParams();
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(user), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api
        .request("post", "/updatauserbyuser?_type=json", params)
        .then(response => {
          var data = response.data;

          if (data.Status !== 1) {
            var errorName = data.ErrorMessage;
            //              添加失败
            if (errorName) {
              utils.showMsg(errorName);
            } else {
              utils.showMsg("updata fail");
            }
            return;
          } else {
            window.location.reload();
          }
        });
    },
    toGetExistUser() {
      //        window.jQuery('#modal-new-a-agent').modal('hide')
      this.existedUser = [];
      this.isSelectAll = false;
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        uid: this.$router.app.$store.state.user.uid
      };
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api
        .request("post", "/getexistuserbyappid?_type=json", params)
        .then(response => {
          var data = response.data;
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
            if (data.Result) {
              var mylist = JSON.parse(
                utils.getDecodeRC4Hex(data.Result, global.APP_SECRET)
              );
              for (var i = 0; i < mylist.length; i++) {
                var hasAdd = false;
                for (var j = 0; j < this.userList.length; j++) {
                  if (mylist[i].uid === this.userList[j].uid) {
                    if (this.userList[j].permission >= 888) {
                      this.existedUser.push({
                        uid: mylist[i].uid,
                        permission: "Admin",
                        isCheck: true,
                        hasAdd: true
                      });
                    } else {
                      this.existedUser.push({
                        uid: mylist[i].uid,
                        permission: "User",
                        isCheck: true,
                        hasAdd: true
                      });
                    }
                    hasAdd = true;
                    break;
                  }
                }
                if (hasAdd === false) {
                  this.existedUser.push({
                    uid: mylist[i].uid,
                    permission: "User",
                    isCheck: false,
                    hasAdd: false
                  });
                }
              }
            }
          }
        });
    },
    toShowNewUserModal(item) {
      this.newUser = {};
      this.newUser.permission = "User";
      window.jQuery("#modal-new-an-agent").modal("show");
    },
    toEditUser(item) {
      this.$store.commit("TOGGLE_FULLSCREEN_LOADING");
      this.editUser = {};
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        uid: item.uid
      };
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api.request("post", "/getuseremail?_type=json", params).then(response => {
        this.$store.commit("TOGGLE_FULLSCREEN_LOADING");
        var data = response.data;
        /* Checking if error object was returned from the server */
        if (data.Status !== 1) {
        } else {
          if (data.Result) {
            var myUser = JSON.parse(
              utils.getDecodeRC4Hex(data.Result, global.APP_SECRET)
            );
            this.$set(this.editUser, "uid", item.uid);
            this.$set(this.editUser, "email", myUser.email);
            // this.editUser.uid = item.uid
            // this.editUser.email = myUser.email
            if (item.permission >= 888) {
              this.$set(this.editUser, "permission", "Admin");
              this.editUser.permission = "Admin";
            } else {
              this.$set(this.editUser, "permission", "User");
            }
            window.jQuery("#modal-edit-agent").modal("show");
          }
        }
      });
    },
    toSelectAllExistUser() {
      this.isSelectAll = !this.isSelectAll;
      for (var i = 0; i < this.existedUser.length; i++) {
        if (!this.existedUser[i].hasAdd) {
          this.existedUser[i].isCheck = this.isSelectAll;
        }
      }
    },
    toAddExistUser() {
      var addExistUserList = [];
      for (var i = 0; i < this.existedUser.length; i++) {
        if (this.existedUser[i].isCheck && !this.existedUser[i].hasAdd) {
          addExistUserList.push({
            uid: this.existedUser[i].uid,
            permission: this.existedUser[i].permission
          });
        }
      }
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        users: addExistUserList
      };
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api.request("post", "/addexistuser?_type=json", params).then(response => {
        var data = response.data;
        /* Checking if error object was returned from the server */
        if (data.Status !== 1) {
        } else {
          window.location.reload();
        }
      });
    },
    toGetAllAgent() {
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid
      };
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api
        .request("post", "/getuserbyappid?_type=json", params)
        .then(response => {
          var data = response.data;
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
            if (data.Result) {
              this.userList = [];
              if (utils.checkIsAppSuperAdmin()) {
                config.isAdminInApp = true;
                this.isAdminInApp = true;
                var localUserString = window.localStorage.getItem("user");
                var localUser = JSON.parse(localUserString);
                this.currentUserPermission = localUser.pm;
              } else {
                config.isAdminInApp = false;
                this.isAdminInApp = false;
              }
              var mylist = JSON.parse(
                utils.getDecodeRC4Hex(data.Result, global.APP_SECRET)
              );
              for (var i = 0; i < mylist.length; i++) {
                if (i === 0) {
                  if (!utils.checkIsAppSuperAdmin()) {
                    this.currentUserPermission = mylist[i].permission;
                  }
                  if (this.currentUserPermission >= 888) {
                    config.isAdminInApp = true;
                    this.isAdminInApp = true;
                  } else {
                    config.isAdminInApp = false;
                    this.isAdminInApp = false;
                  }
                }
                this.userList.push({
                  uid: mylist[i].uid,
                  permission: mylist[i].permission
                });
              }
            }
          }
        });
    },
    toGetAllAgentByUid(uid) {
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        uid: uid
      };
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api.request("post", "/searchuser?_type=json", params).then(response => {
        var data = response.data;
        /* Checking if error object was returned from the server */
        if (data.Status !== 1) {
        } else {
          if (data.Result) {
            this.userList = [];
            if (utils.checkIsAppSuperAdmin()) {
              config.isAdminInApp = true;
              this.isAdminInApp = true;
            } else {
              config.isAdminInApp = false;
              this.isAdminInApp = false;
            }
            var mylist = JSON.parse(
              utils.getDecodeRC4Hex(data.Result, global.APP_SECRET)
            );
            for (var i = 0; i < mylist.length; i++) {
              this.userList.push({
                uid: mylist[i].uid,
                permission: mylist[i].permission
              });
            }
          }
        }
      });
    },
    handleEditPrivilege(user) {
      this.$refs.privilegeModal.show(user.uid);
    }
  },
  mounted() {
    this.init();
    this.$nextTick(() => {
      window.jQuery.getScript(pluginURL, () => {
        window.jQuery.getScript(mapURL, () => {
          window.jQuery("#world-map-markers").vectorMap({
            map: "world_mill"
          });
        });
      });
    });
  }
};
</script>

<style>
.fake {
  color: "red";
}

#world-map-markers svg {
  height: 355px;
}

.row.no-gutters {
  margin-right: 0;
  margin-left: 0;
}

.row.no-gutters > [class^="col-"],
.row.no-gutters > [class*=" col-"] {
  padding-right: 0;
  padding-left: 0;
}

.fa-star {
  color: #605ca8;
}

.fa-star-o {
  color: #605ca8;
}

.example-modal .modal {
  position: fixed;
  display: block;
  z-index: 999999;
}

.example-modal .modal {
  /*background: transparent !important;*/
  background: #000000 0.3 !important;
}

.form-horizontal .form-group {
  margin-right: 0px;
  margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// Agent.vue?721fd7b5